import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";

export class RfidTagRequest{
    @ApiProperty()
    plantId:number;
    @ApiProperty({
        default: ''
    })
    @IsOptional()
    rfId:string;
    @ApiProperty({
        default: ''
    })
    @IsOptional()
    palletId:string;
    @ApiProperty({
        default: ''
    })
    @IsOptional()
    rackId:string;

}